import { FC } from "react";
import { pluralizeWithCount } from "@common/helpers/string";
import { BulkClassCommandsList } from "./BulkClassCommandsList";
import { CommandsListProps } from "./lib";

export const CatalogItemBulkClassCommandsList: FC<CommandsListProps> = ({
    options = {},
}) => {
    const {
        selectedCatalogItemCount = 0,
        catalogItemBulkClassTree = [],
        catalogItemBulkClassesMap,
        catalogItemApplyClasses,
    } = options;

    return (
        <BulkClassCommandsList
            heading={`Set class for ${pluralizeWithCount("item", selectedCatalogItemCount)}`}
            classTree={catalogItemBulkClassTree}
            classesMap={catalogItemBulkClassesMap}
            onApply={(classIds) => catalogItemApplyClasses?.(classIds)}
        />
    );
};
